import { ActionTree } from 'vuex';
import { RootState } from '@/types';
import { ICampaignSitesState, ISites } from '@/types/campaign/sites';

const actions: ActionTree<ICampaignSitesState, RootState> = {
  setDomains({ commit }, sites) {
    const formatSites = {
      byDomain: {},
      allDomains: []
    } as ISites;

    for (const site of sites) {
      site.status = true;
      formatSites.byDomain[site.domain] = site
      formatSites.allDomains.push(site.domain);
    }

    commit('setSites', formatSites);
  },
};

export default actions;
